export default __webpack_public_path__ + "static/media/cart.b29d4af8.svg";